module.exports = __webpack_public_path__ + "../resources/img/bg_grid1_03.13fffa7f.png";